import React from 'react';

/**
 * Grouped, borderless KPI tiles (spec §9). Each tile optionally click-throughs
 * to a filtered table. Tone tints the value via CSS-variable status colors.
 */

export type KpiTone =
  | 'default'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'muted';

export const KpiTile: React.FC<{
  label: string;
  value: React.ReactNode;
  tone?: KpiTone;
  hint?: string;
  onClick?: () => void;
}> = ({ label, value, tone = 'default', hint, onClick }) => {
  const content = (
    <>
      <span className={`eh-kpi-value eh-kpi-${tone}`}>{value}</span>
      <span className='eh-kpi-label'>{label}</span>
      {hint && <span className='eh-kpi-hint'>{hint}</span>}
    </>
  );
  if (onClick) {
    return (
      <button type='button' className='eh-kpi-tile clickable' onClick={onClick}>
        {content}
      </button>
    );
  }
  return <div className='eh-kpi-tile'>{content}</div>;
};

export const KpiGroup: React.FC<{
  title?: string;
  children: React.ReactNode;
}> = ({ title, children }) => (
  <div className='eh-kpi-group'>
    {title && <div className='eh-kpi-group-title'>{title}</div>}
    <div className='eh-kpi-grid'>{children}</div>
  </div>
);
